import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAccessPage } from '../../../helpers/user/UserHelper'

const AccessPageBlock = () => {

    const user = useSelector(state => state.user.user)
    const navigate = useNavigate()
    
    useEffect(() => {
        // Перевірка доступу до розділу
        const access = getAccessPage({ 
            path: window.location.pathname,
            permissions: user && user.permissions ? user.permissions : []
        })

        if (!access) {
            navigate('/403')
        }
    }, [])

  return (
    <></>
  )
}

export default AccessPageBlock